export default __webpack_public_path__ + "static/4-concurrency-b-0e2871fbaae3367c5ceec4ad643a8741.jpg";